//Generated File 
export default class GridAction{
	static readonly DeleteLine = `DeleteLine`;
	static readonly InsertLine = `InsertLine`;
	static readonly PrevalidateColumns = `PrevalidateColumns`;
}
